import PropertyReg from './PropertyRegContent'
import PropertyContextProvider from '../../context/property-context'

function PropertyContextWrapper(props) {
    return (
        <PropertyContextProvider>
            <PropertyReg/>
        </PropertyContextProvider>
    )
}

export default PropertyContextWrapper 